import { Text, TextProps } from '@chakra-ui/react'
import React from 'react'
import MissingText from './missing-text'

interface Props extends TextProps {
    isMissing?: boolean
    textComponent?: React.FC
    existingTextProps?: TextProps
    missingTextProps?: TextProps
    missingText?: string
}

export default function MaybeMissingText({
    isMissing,
    missingText = 'N/A',
    missingTextProps,
    existingTextProps,
    children,
    ...props
}: Props) {
    if (!children || isMissing) {
        return (
            <MissingText {...props} {...missingTextProps}>
                {missingText}
            </MissingText>
        )
    }

    const TextComponent = props.textComponent || Text

    return (
        <TextComponent {...props} {...existingTextProps}>
            {children}
        </TextComponent>
    )
}
